module.exports = __webpack_public_path__ + "static/media/customerService2.2e1d7955.png";